/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon64Regular = forwardRef('FlagAIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 6A5.5 5.5 0 0 0 7 11.5v49a1.5 1.5 0 0 0 3 0V46h43.882c2.514 0 3.913-2.908 2.343-4.873L44.14 26l12.085-15.127C57.795 8.908 56.396 6 53.882 6H12.5ZM10 43h43.882L41.796 27.872a3 3 0 0 1 0-3.744L53.882 9H12.5a2.5 2.5 0 0 0-2.5 2.5V43Z" })));
});
